"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultChoiceValue = void 0;
exports.defaultChoiceValue = { label: "", value: null };
